<script setup lang="ts">
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/SliderBottom2'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-10 px-2xl mb-20 flex flex-col gap-10 bg-background-1"
    >
      <div class="flex flex-col gap-10 items-start">
        <div class="border-b border-Tertiary py-1">
          <span class="text-Tekst text-H4 font-semibold">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'tekst_4']"
            />
          </span>
        </div>
      </div>
      <div class="flex flex-col xl:grid grid-cols-2 gap-16">
        <span class="text-Tekst text-H4">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'tekst_2']"
          />
        </span>
        <span class="text-Tekst text-H4">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'tekst_3']"
          />
        </span>
      </div>
    </div>
  </CmsCustomComponent>
</template>
